import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, createStyles } from '@mui/styles'
// import { SvgIconProps } from '@mui/material/SvgIcon'

import List from '@mui/material/List'

import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Divider from '@mui/material/Divider'
import Collapse from '@mui/material/Collapse'

import IconExpandLess from '@mui/icons-material/ExpandLess'
import IconExpandMore from '@mui/icons-material/ExpandMore'

import AppMenuItemComponent from './appmenucomponent'

// React runtime PropTypes
export const AppMenuItemPropTypes = {
  name: PropTypes.string.isRequired,
  link: PropTypes.string,
  Icon: PropTypes.elementType,
  items: PropTypes.array,
}

const AppMenuItem = props => {
  const { name, link, Icon, items = [], state, disabled, onClick } = props
  const classes = useStyles()
  const isExpandable = items && items.length > 0
  const [open, setOpen] = React.useState(false)

  function handleClick() {
    setOpen(!open)
  }

  const MenuItemRoot = (
    <AppMenuItemComponent className={classes.menuItem} link={disabled ? null : link} onClick={onClick ? onClick : handleClick} state={state}>
      {/* Display an icon if any */}
      {!!Icon && (
        <ListItemIcon className={classes.menuItemIcon}>
          <Icon />
        </ListItemIcon>
      )}
        <ListItemText primary={name} inset={!Icon} />
      {/* Display the expand menu if the item has children */}
      {isExpandable && !open && <IconExpandMore />}
      {isExpandable && open && <IconExpandLess />}
    </AppMenuItemComponent>
  )

  const MenuItemChildren = isExpandable ? (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Divider />
      <List component="div" disablePadding>
        {items.map((item, index) => (
          <AppMenuItem disabled={item.disabled ?? false} {...item} key={index} />
        ))}
      </List>
    </Collapse>
  ) : null

  return (
    <>
      {MenuItemRoot}
      {MenuItemChildren}
    </>
  )
}

const useStyles = makeStyles(theme =>
  createStyles({
    menuItem: {
      borderRadius: 'var(--radius-md)',
      margin: '0 var(--space-2) var(--space-1)',
      transition: 'var(--transition-fast)',
      color: 'var(--text-primary)',
      '&:hover': {
        background: 'var(--mexx-green-subtle)',
        color: 'var(--mexx-green-primary)',
        '& .MuiListItemIcon-root': {
          color: 'var(--mexx-green-primary)',
        },
      },
      '&.active': {
        background: 'var(--mexx-green-light)',
        color: 'var(--mexx-green-dark)',
        '& .MuiListItemIcon-root': {
          color: 'var(--mexx-green-dark)',
        },
      },
    },
    menuItemIcon: {
      color: 'var(--mexx-green-primary)',
      minWidth: '40px',
    },
  }),
)

export default AppMenuItem
